export default __webpack_public_path__ + "static/media/css.84e42507.svg";